/* DeoDap — product card ⇄ cart sync   (v3) */
(function () {
  'use strict';

  /* ---- selectors, from the live card markup ---- */
  var WRAP_SEL    = '.quantity-add-to-cart-btns[data-variant-id]';
  var INPUT_SEL   = '.card-quantity-input, .custom-quantity-input, .quantity__input';
  var ADDED_CLASS = 'added-item';

  var CART_TRIGGER_SEL = '#cart-icon-bubble, .header__icon--cart, .dd-hd-cart, a[href="/cart"], a[href$="/cart"], cart-drawer, .cart-drawer-toggle';

  var POLL_MS        = 1200;
  var POLL_WINDOW    = 45000;
  var DEBOUNCE_MS    = 350;
  var TOUCH_GRACE_MS = 1500;   /* hands off a card the customer is using */

  var pollTimer  = null;
  var pollUntil  = 0;
  var syncTimer  = null;
  var retryTimer = null;
  var lastSig    = null;
  var lastTouch  = new WeakMap();

  /* ------------------------------------------------------------
     Track which card the customer is interacting with.
     ------------------------------------------------------------ */
  ['click', 'input', 'change', 'keydown'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var wrap = t.closest(WRAP_SEL);
      if (wrap) lastTouch.set(wrap, Date.now());
    }, true);
  });

  function busyFor(wrap) {
    var t = lastTouch.get(wrap);
    if (!t) return 0;
    var left = TOUCH_GRACE_MS - (Date.now() - t);
    return left > 0 ? left : 0;
  }

  /* ------------------------------------------------------------
     Remember each card's original quantity (its MOQ) so removal
     resets to what Liquid rendered, not a hardcoded 1.
     ------------------------------------------------------------ */
  function baseQty(wrap) {
    if (wrap.dataset.ddBaseQty) return wrap.dataset.ddBaseQty;
    var input = wrap.querySelector(INPUT_SEL);
    var base  = (input && input.getAttribute('value')) || '1';
    wrap.dataset.ddBaseQty = base;
    return base;
  }

  /* ------------------------------------------------------------
     Paint every card. Returns the ms to wait before retrying if
     any card was skipped, or 0 when the paint was complete.
     ------------------------------------------------------------ */
  function applyCart(cart) {
    var qtyByVariant = {};
    (cart.items || []).forEach(function (item) {
      var id = String(item.variant_id);
      qtyByVariant[id] = (qtyByVariant[id] || 0) + item.quantity;
    });

    var retryIn = 0;

    document.querySelectorAll(WRAP_SEL).forEach(function (wrap) {
      var id = String(wrap.getAttribute('data-variant-id') || '').trim();
      if (!id) return;

      baseQty(wrap);

      var wait = busyFor(wrap);
      if (wait > 0) {
        /* customer is mid-interaction — skip, and make sure we come back */
        if (wait > retryIn) retryIn = wait;
        return;
      }

      var qty   = qtyByVariant[id] || 0;
      var input = wrap.querySelector(INPUT_SEL);

      if (qty > 0) {
        if (!wrap.classList.contains(ADDED_CLASS)) wrap.classList.add(ADDED_CLASS);
        if (input && String(input.value) !== String(qty)) {
          input.value = qty;
          input.setAttribute('value', qty);
        }
      } else {
        if (wrap.classList.contains(ADDED_CLASS)) wrap.classList.remove(ADDED_CLASS);
        var base = baseQty(wrap);
        if (input && String(input.value) !== String(base)) {
          input.value = base;
          input.setAttribute('value', base);
        }
      }
    });

    return retryIn;
  }

  /* ------------------------------------------------------------
     Fetch the cart and apply it.
     ------------------------------------------------------------ */
  function sync(immediate) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(run, immediate ? 0 : DEBOUNCE_MS);
  }

  function run() {
    fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;

        var sig = (cart.items || []).map(function (i) {
          return i.variant_id + ':' + i.quantity;
        }).join('|');

        /* Re-run even on an unchanged signature when a retry is pending —
           a skipped card still needs its paint. */
        if (sig === lastSig && !retryTimer) return;

        var retryIn = applyCart(cart);

        if (retryIn > 0) {
          /* paint incomplete: do NOT cache the signature, or the retry
             would be swallowed by the early return above */
          clearTimeout(retryTimer);
          retryTimer = setTimeout(function () {
            retryTimer = null;
            run();
          }, retryIn + 100);
        } else {
          lastSig = sig;
          clearTimeout(retryTimer);
          retryTimer = null;
        }

        startPollWindow();
      })
      .catch(function () { /* stay silent — never break the page */ });
  }

  /* ------------------------------------------------------------
     Bounded polling fallback.
     ------------------------------------------------------------ */
  function startPollWindow() {
    pollUntil = Date.now() + POLL_WINDOW;
    if (pollTimer) return;
    pollTimer = setInterval(function () {
      if (Date.now() > pollUntil || document.visibilityState !== 'visible') {
        clearInterval(pollTimer);
        pollTimer = null;
        return;
      }
      run();
    }, POLL_MS);
  }

  /* ------------------------------------------------------------
     Tier 1 — intercept cart mutations made with fetch or XHR
     ------------------------------------------------------------ */
  var CART_URL_RE = /\/cart\/(add|change|update|clear)(\.js)?/i;

  (function patchFetch() {
    var orig = window.fetch;
    if (typeof orig !== 'function' || orig.__ddCardSyncPatched) return;
    window.fetch = function () {
      var a   = arguments[0];
      var url = typeof a === 'string' ? a : (a && a.url) || '';
      var res = orig.apply(this, arguments);
      if (CART_URL_RE.test(url)) {
        try { res.then(function () { sync(); }).catch(function () {}); } catch (e) {}
      }
      return res;
    };
    window.fetch.__ddCardSyncPatched = true;
  })();

  (function patchXHR() {
    var proto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (!proto || proto.__ddCardSyncPatched) return;
    var origOpen = proto.open;
    proto.open = function (method, url) {
      try { this.__ddCartUrl = url; } catch (e) {}
      return origOpen.apply(this, arguments);
    };
    var origSend = proto.send;
    proto.send = function () {
      try {
        if (CART_URL_RE.test(this.__ddCartUrl || '')) {
          this.addEventListener('loadend', function () { sync(); });
        }
      } catch (e) {}
      return origSend.apply(this, arguments);
    };
    proto.__ddCardSyncPatched = true;
  })();

  /* ------------------------------------------------------------
     Tier 2 — theme events
     ------------------------------------------------------------ */
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:added', 'dd:cart-added']
    .forEach(function (ev) {
      document.addEventListener(ev, function () { sync(); });
    });

  function hookPubSub() {
    if (hookPubSub.done) return;
    if (typeof window.subscribe !== 'function' || !window.PUB_SUB_EVENTS) return;
    try {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { sync(); });
      hookPubSub.done = true;
    } catch (e) {}
  }
  hookPubSub();

  /* ------------------------------------------------------------
     Tier 3 — cart opened: watch for a while
     ------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest(CART_TRIGGER_SEL)) {
      startPollWindow();
      sync();
    }
  }, true);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') sync(true);
  });
  window.addEventListener('pageshow', function () { sync(true); });

  (function watchForNewCards() {
    if (typeof MutationObserver !== 'function' || !document.body) return;

    var pending = null;
    var obs = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches(WRAP_SEL)) { schedule(); return; }
          if (n.querySelector && n.querySelector(WRAP_SEL)) { schedule(); return; }
        }
      }
    });

    function schedule() {
      clearTimeout(pending);
      pending = setTimeout(function () {
        lastSig = null;      /* new cards need painting even if the cart is unchanged */
        sync(true);
      }, 150);
    }

    obs.observe(document.body, { childList: true, subtree: true });
  })();

  document.addEventListener('shopify:section:load', function () {
    lastSig = null;
    sync(true);
  });

  /* ---- first run ---- */
  function boot() { hookPubSub(); sync(true); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();